import { StaticRouter } from "react-router-dom/server";

import { RendererProvider } from "@atlassiansox/bxp-content-framework";

import {
    AnalyticsProvider,
    AnalyticsAttributesProvider,
    FooterContextProvider,
    RouteProvider
} from "../entries/components";
import { StaticLanguageProvider } from "../entries/components/hooks/use-language";
import { renderViewModel } from "../entries/render-view-model";

import type { ViewModel } from "../entries/view-models";

type NotFoundPageProps = {
    pageModel?: { content?: { header?: ViewModel } } | null;
};

/**
 * 404 Not Found page for Trello portal.
 * Matches the classic Trello SPA 404 experience at trello.com/<unknown-route>.
 * Renders the real Trello header from the provided pageModel (sourced from the
 * home page) so the nav is present, then shows the static 404 body.
 */
export const NotFoundPage = ({ pageModel }: NotFoundPageProps = {}) => {
    const header = pageModel?.content?.header;
    return (
        <>
            {header && (
                <StaticRouter location="/">
                    <StaticLanguageProvider language="en">
                        <AnalyticsAttributesProvider
                            value={{ eventContainer: "globalNav" }}
                        >
                            <RouteProvider value="/">
                                <AnalyticsProvider>
                                    <RendererProvider
                                        renderer={renderViewModel}
                                    >
                                        <FooterContextProvider>
                                            {renderViewModel(header)}
                                        </FooterContextProvider>
                                    </RendererProvider>
                                </AnalyticsProvider>
                            </RouteProvider>
                        </AnalyticsAttributesProvider>
                    </StaticLanguageProvider>
                </StaticRouter>
            )}
            <div
                id="trello-root"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "80px 24px",
                    minHeight: "400px",

                    fontFamily:
                        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Noto Sans, Ubuntu, Droid Sans, 'Helvetica Neue', sans-serif",
                    // eslint-disable-next-line local/ensure-wac-token-usage
                    color: "#172b4d"
                }}
            >
                <h1
                    style={{
                        fontSize: "20px",

                        fontWeight: 700,

                        marginBottom: "8px"
                    }}
                >
                    Page not found.
                </h1>
                <p
                    style={{
                        fontSize: "16px",

                        margin: 0
                    }}
                >
                    This page may be private. You may be able to view it by{" "}
                    <a href="/login" className="js-login">
                        logging in
                    </a>
                    .
                </p>
            </div>
        </>
    );
};
